import qs from 'qs';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFunction = (func) => func && {}.toString.call(func) === '[object Function]';
export const parseParams = (url) => {
    const [path, paramString] = url.split('?');
    return [path, paramString ? qs.parse(paramString) : {}];
};
export const mergeParams = (override = true) => (...args) => args.filter(Boolean).reduce((params, arg) => {
    Object.keys(arg).forEach((param) => {
        params[param] =
            params[param] && !override
                ? Array.isArray(params[param])
                    ? [arg[param], ...params[param]]
                    : [arg[param], params[param]]
                : arg[param];
    });
    return params;
}, {});
// parses values with || and returns either or depending on the passed boolean
export const eitherOr = (bool) => (val) => {
    const value = Array.isArray(val) ? val : [val];
    const either = value[0];
    const or = value[1];
    const condition = bool ? either : or;
    return or === undefined ? either : condition;
};
/*
  `eitherOrWithCount` decides which parameter to choose depending on:
    `count` - notifications count, could be provided or undefined (if no badge is expected)
    `val` - tracking parameter, could be an array (tracking with badge or without badge) or a single value (if no badge is expected)

  Difference from `eitherOr`: adds to the tracking parameter (with badge) the number of notifications

  Logic depends heavily on the structure of tracking data: packages/layout/trackings/src/navigation.js
*/
export const eitherOrWithCount = (count) => (val) => {
    const isChangeable = Array.isArray(val);
    if (isChangeable) {
        const [either, or] = val;
        return count ? `${either}_${count}` : or;
    }
    else {
        const or = val;
        return or;
    }
};
const isBoolean = (value) => typeof value === 'boolean';
export const trackingURL = (to, key = '', conditions = {}, options = {
    encode: true,
    arrayFormat: 'repeat', // 'a=b&a=c',
}) => (tracking) => {
    const [path, params] = parseParams(to);
    const paramsWithTrackings = mergeParams(true)(params, tracking[key]);
    const updatedParams = Object.keys(paramsWithTrackings).reduce((obj, key) => {
        const value = isFunction(conditions[key])
            ? conditions[key](paramsWithTrackings[key])
            : isBoolean(conditions[key])
                ? eitherOr(conditions[key])(paramsWithTrackings[key])
                : paramsWithTrackings[key];
        return { ...obj, [key]: value };
    }, {});
    const queryString = qs.stringify(updatedParams, options);
    return queryString.length ? `${path}?${queryString}` : path;
};
//# sourceMappingURL=xing-tracking.js.map